export enum ErrorCodes {
  // playback errors
  recordingIdMissing = 1000,
  epgIdMissing,
  languageIdMissing,
  subtitleIdMissing,
  errorIdMissing,
  audioTrackIdMissing,

  // device action error
  initiatedByMissing = 2000,
  swVersionMissing,
  customDataMissing,

  // configuration errors
  missingPluginEndpointUrl = 5000,
}

export const errorCodeMessageMapping = {
  [ErrorCodes.recordingIdMissing]: 'recordingId is mandatory when mediaType equals RECORDING',
  [ErrorCodes.epgIdMissing]: 'epgId is mandatory when mediaType equals LIVE',
  [ErrorCodes.languageIdMissing]: 'languageID missing for action LANG',
  [ErrorCodes.subtitleIdMissing]: 'subtitleID missing for action SUB_CHANGE',
  [ErrorCodes.errorIdMissing]: 'errorID missing for action CONCURRENCY_CN',
  [ErrorCodes.audioTrackIdMissing]: 'audioTrackID missing for action AUDIO',
  [ErrorCodes.initiatedByMissing]: 'initiatedBy param missing',
  [ErrorCodes.swVersionMissing]: 'swVersion param missing',
  [ErrorCodes.customDataMissing]: 'custom param missing',
  [ErrorCodes.missingPluginEndpointUrl]: 'endpointUrl missing in plugin config',
};

export class AnalyticsError extends Error {
  public readonly code: ErrorCodes;

  constructor(public errorCode: ErrorCodes) {
    super(errorCodeMessageMapping[errorCode]);
    this.name = `AnalyticsError[${errorCode}]`;
    this.code = errorCode;
  }
}
